import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Status } from '@df/core/status';
import { Basket } from '@df/session/api/basket/basket';
import { Subscription } from 'rxjs';
import { NFurnitureAssembly } from './furniture-assembly.namespace';
import { FurnitureAssemblyService } from './furniture-assembly.service';
import { FurnitureAssemblyItemComponent } from './item/furniture-assembly-item.component';
@Component({
    selector: 'furniture-assembly',
    templateUrl: '/furniture-assembly.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, FurnitureAssemblyItemComponent]
})
export class FurnitureAssemblyComponent implements OnInit, OnDestroy {
    assemblyItems?: NFurnitureAssembly.IAssemblyItem[];
    private subscriptions = new Subscription();
    private status = new Status();
    constructor(
        private furnitureAssemblyService: FurnitureAssemblyService,
        private changeDetectorRef: ChangeDetectorRef,
        private basket: Basket
    ) {}
    ngOnInit(): void {
        this.subscriptions.add(this.basket.subscribe(() => this.onBasketUpdate()));
        this.onBasketUpdate();
    }
    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
    private onBasketUpdate(): void {
        const onFinish = () => {
            this.assemblyItems = this.furnitureAssemblyService.getAvailableAssemblyItems();
            this.changeDetectorRef.detectChanges();
        };
        this.furnitureAssemblyService.loadProducts(this.status, onFinish, onFinish);
    }
    trackByAssemblyType(index: number, item: NFurnitureAssembly.IAssemblyItem): NFurnitureAssembly.EType {
        return item.type;
    }
}
